import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';

import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';

import DeleteIcon from 'material-ui/svg-icons/action/delete';

import CategoryActions from '../../actions/CategoryActionCreator';
import OrganisationCategoryStore from '../../stores/OrganisationCategoryStore';


class OrganisationCategoriesTable extends Component {

    componentDidMount() {
        CategoryActions.getAllByOrganisation(this.props.organisationId);
    }

    render() {
        return (
            <Table selectable={false}>
                <TableHeader enableSelectAll={false} displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                        <TableHeaderColumn>Module</TableHeaderColumn>
                        <TableHeaderColumn>Can Edit</TableHeaderColumn>
                        <TableHeaderColumn>Can Add Subcategories</TableHeaderColumn>
                        <TableHeaderColumn>Can Add Content</TableHeaderColumn>
                        <TableHeaderColumn/>
                    </TableRow>
                </TableHeader>
                <TableBody deselectOnClickaway={false} showRowHover={false} stripedRows={false} displayRowCheckbox={false}>
                    {this.state.categories.map(({categoryId, categoryName, canEdit, canAddSubcategories, canAddContent}) => (
                        <TableRow key={categoryId}>
                            <TableRowColumn>{categoryName}</TableRowColumn>
                            <TableRowColumn>
                                <Checkbox
                                    name="Can edit"
                                    defaultChecked={canEdit}
                                    onCheck={(e, value) => CategoryActions.updateOrganisation(categoryId, this.props.organisationId, {canEdit: value})}
                                />
                            </TableRowColumn>
                            <TableRowColumn>
                                <Checkbox
                                    name="Can add subcategories"
                                    defaultChecked={canAddSubcategories}
                                    onCheck={(e, value) => CategoryActions.updateOrganisation(categoryId, this.props.organisationId, {canAddSubcategories: value})}
                                />
                            </TableRowColumn>
                            <TableRowColumn>
                                <Checkbox
                                    name="Can add content"
                                    defaultChecked={canAddContent}
                                    onCheck={(e, value) => CategoryActions.updateOrganisation(categoryId, this.props.organisationId, {canAddContent: value})}
                                />
                            </TableRowColumn>
                            <TableRowColumn>
                                <IconButton onClick={() => CategoryActions.removeOrganisation(categoryId, this.props.organisationId)}>
                                    <DeleteIcon/>
                                </IconButton>
                            </TableRowColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }
}

OrganisationCategoriesTable.getStores = () => [OrganisationCategoryStore];

OrganisationCategoriesTable.calculateState = (prevState, {organisationId}) => ({
    categories: OrganisationCategoryStore.getByOrganisation(organisationId) || []
});

OrganisationCategoriesTable.propTypes = {
    organisationId: PropTypes.number.isRequired,
};

export default Container.create(OrganisationCategoriesTable, {withProps: true});
